import { t } from '@lingui/core/macro';
import { FilterButton, Menu } from '@pocketlaw/tetris';
import { MenuSingleSelectItem } from 'shared/domains/common-ui/SearchableMenu';
import { useFilter } from '../useFilter';
export function NullOperator(props) {
    const { name } = props;
    const filter = useFilter(name);
    const items = [
        {
            id: 'not-set',
            value: { isNull: true },
            title: t({ message: 'No value', comment: 'Insights: Boolean filter - has no value set' }),
        },
        {
            id: 'set',
            value: { isNull: false },
            title: t({
                message: 'Any value',
                comment: 'Insights: Boolean filter - has any value set',
            }),
        },
    ];
    const selectedItem = items.find((item) => {
        const currentValue = JSON.stringify(filter.value);
        const itemValue = JSON.stringify(item.value);
        return currentValue === itemValue;
    });
    const selectedValue = (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.title) || t({ message: 'Select value', comment: 'Search filter: NULL operator placeholder' });
    return (<Menu.Root target={<FilterButton appearance={filter.isTouched ? 'draft' : 'default'}>{selectedValue}</FilterButton>}>
      {items.map((item) => (<MenuSingleSelectItem key={item.id} selected={(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) === item.id} onClick={() => filter.applyValue(item.value)}>
          {item.title}
        </MenuSingleSelectItem>))}
    </Menu.Root>);
}
